import { Card } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import {
	clearExpenseForm,
	loadSingleExpenseForm,
} from "../../redux/rtk/features/expense/expenseSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ReviewExpensePopup from "../UI/PopUp/ReviewExpensePopup";

const DetailExpense = () => {
	const { id } = useParams("id");
	const expense = useSelector((state) => state.expense.expense);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadSingleExpenseForm(id));

		return () => {
			dispatch(clearExpenseForm());
		};
	}, []);
	console.log("Expense Attachment: ", expense?.attachment);


	const handleDownload = (e) => {
		e.preventDefault();
		const token = getUserFromToken();
		if (!token) {
			console.error("Authorization token missing");
			return;
		}

		fetch(expense.expenseProofUrl, {
			method: "GET",
			headers: {
				Authorization: `Bearer ${localStorage.getItem("access-token")}`,
			},
		})
			.then((response) => {
				if (response.ok) {
					return response.blob();
				} else {
					throw new Error("Authorization failed");
				}
			})
			.then((blob) => {
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement("a");
				a.href = url;
				a.download = "attachment";
				document.body.appendChild(a);
				a.click();
				a.remove();
			})
			.catch((error) => {
				console.error("Error downloading attachment: ", error);
			});
	};

	return (
		<div>
			<PageTitle title='Back' />
			<UserPrivateComponent permission={"readSingle-leaveApplication"}>
				<Card className='mt-4'>
					<div className='text-center mb-4'>
						{" "}
						<h2 className='text-2xl font-semibold text-gray-600'>
							Expense Sheet #{expense?.id}{" "}
						</h2>
					</div>
					{expense ? (
						<div className='flex justify-center '>
							<ul className='list-inside list-none border-2 border-inherit rounded px-5 py-5 '>
								<ListItem>
									Name :{" "}
									<TextInside>
										{(
											expense?.user.firstName +
											" " +
											expense?.user.lastName
										).toUpperCase()}{" "}
									</TextInside>
								</ListItem>
								<ListItem>
									Expense Title : <TextInside>{expense.expenseTitle}</TextInside>
								</ListItem>
								<ListItem>
									Expense Amount :<TextInside>Rs. {expense.expenseAmount}</TextInside>
								</ListItem>
								<ListItem>
									Expense Date :{" "}
									<TextInside>
										{dayjs(expense.expenseDate).format("DD-MM-YYYY")}
									</TextInside>
								</ListItem>

								{/* <ListItem>
									Expense Duration :{" "}
									<TextInside className='text-red-500'>
										{expense.expenseDuration}
									</TextInside>
								</ListItem>

								<ListItem>
									Expense Reason :{" "}
									<TextInside>{expense.reason || "No reason"}</TextInside>
								</ListItem> */}

								<ListItem>
									Expense Status :{" "}
									<TextInside>
										{expense.approvalStatus === "PENDING" ? (
											<span className='text-yellow-500'>
												{expense.approvalStatus.toUpperCase()}
											</span>
										) : expense.approvalStatus === "APPROVED" ? (
											<span className='text-green-500'>
												{expense.approvalStatus.toUpperCase()}
											</span>
										) : expense.approvalStatus === "PARTIAL APPROVED" ? (
											<span className='text-orange-500'>
												{expense.approvalStatus.toUpperCase()}
											</span>
										) : (
											<span className='text-red-500'>
												{expense.approvalStatus.toUpperCase()}
											</span>
										)}
									</TextInside>
								</ListItem>

								{/* <ListItem>
									Expense Accepted From :{" "}
									<TextInside>
										{expense.acceptExpenseFrom
											? dayjs(expense.acceptExpenseFrom).format("DD-MM-YYYY")
											: "ON REVIEW"}
									</TextInside>
								</ListItem> */}
								<ListItem>
									Approved Amount :<TextInside>Rs. {expense.approvedAmount}</TextInside>
								</ListItem>

								<ListItem>
									Approval Date :{" "}
									<TextInside>
										{expense.approvedDate
											? dayjs(expense.approvedDate).format("DD-MM-YYYY")
											: "ON REVIEW"}
									</TextInside>
								</ListItem>

								<ListItem>
									Expense Approved By :{" "}
									<TextInside className='text-green-500'>
										{(expense.approveExpenseBy?.firstName || "ON") +
											" " +
											(expense.approveExpenseBy?.lastName || "REVIEW")}
									</TextInside>
								</ListItem>

								<ListItem>
									Review Comment :{" "}
									<TextInside>{expense.reviewComment || "No comment"}</TextInside>
								</ListItem>

								<ListItem>
									Payment Status :{" "}
									<TextInside>
										{expense.paymentStatus === "Unpaid" ? (
											<span className='text-red-500'>
												{expense.paymentStatus.toUpperCase()}
											</span>
										) : expense.paymentStatus === "PAID" ? (
											<span className='text-green-500'>
												{expense.paymentStatus.toUpperCase()}
											</span>
										) : (
											<span className='text-yellow-500'>
												{expense.paymentStatus.toUpperCase()}
											</span>
										)}
									</TextInside>
								</ListItem>

								<ListItem>
									Attachment:{" "}
									<TextInside>
										{expense.attachment ? (
											<a
												href={expense.expenseProofUrl}
												onClick={handleDownload} // Attach the download handler
												className="text-blue-500"
											>
												Download
											</a>
										) : (
											"No Attachment"
										)}
									</TextInside>
								</ListItem>

							</ul>
						</div>
					) : (
						<Loader />
					)}
					<UserPrivateComponent permission={"update-leaveApplication"}>
						{expense?.approvalStatus === "PENDING" && (
							<div className='flex justify-center items-center'>
								<ReviewExpensePopup />
							</div>
						)}
						{expense?.approvalStatus === "REJECTED" && (
							<div className='flex justify-center items-center'>
								<ReviewExpensePopup />
							</div>
						)}
					</UserPrivateComponent>
				</Card>
			</UserPrivateComponent>
		</div>
	);

	// "reviewComment": null,
	// "attachment": null,
};

const ListItem = tw.li`
text-sm
text-gray-600
font-semibold
py-2
px-4
bg-gray-100
mb-1.5
rounded
w-96
flex
justify-start
`;

const TextInside = tw.p`
ml-2
text-sm
text-gray-900
`;
export default DetailExpense;
